import { createContext, useContext } from 'react';

import type { DialogFlowStepContext } from './types';

export const DialogFlowContext = createContext<DialogFlowStepContext | null>(
  null,
);

export const useDialogFlowContext = () => {
  const context = useContext(DialogFlowContext);
  if (!context) {
    throw new Error('useDialogFlowContext must be used within DialogFlow');
  }
  return context;
};
